@if (active()) {
  <div class="loader-overlay">
    <img class="icon-xxl" src="assets/images/logoanimation-small.svg" alt="Loading..." />
  </div>
}
